var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1280_35642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4562 15.844C10.2012 15.934 9.78121 15.934 9.52621 15.844C7.35121 15.1015 2.49121 12.004 2.49121 6.75402C2.49121 4.43652 4.35871 2.56152 6.66121 2.56152C8.02621 2.56152 9.23371 3.22152 9.99121 4.24152C10.3765 3.72093 10.8784 3.29782 11.4567 3.00608C12.035 2.71434 12.6735 2.56209 13.3212 2.56152C15.6237 2.56152 17.4912 4.43652 17.4912 6.75402C17.4912 12.004 12.6312 15.1015 10.4562 15.844Z",
    stroke: "#A3AED0",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1280_35642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.991211 0.236328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBorder);
export default __webpack_public_path__ + "static/media/heartBorder.dc76beb989e1221cd7b92b29fe0b9af2.svg";
export { ForwardRef as ReactComponent };